export default {
      id: "icon-checkbox-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-checkbox",
      toString: function () {
        return this.url;
      }
    }